import { Messages } from "../../lib/locale";

export const Italian: Messages = {
  name: "Italiano",
  helpTitle: "Come giocare",
  help1: `Il tuo compito è scoprire quale paese è nascosto nel gioco. Per fare ciò, devi inserire i nomi di paesi casuali. Scrivi il paese nella casella di input e premi Invio. Questo paese apparirà sulla mappa e cambierà colore a seconda di quanto è vicino al paese nascosto. Più scuro è il colore, più sei vicino alla risposta!`,
  help2: `Guarda l'esempio del gioco. Diciamo che il paese in cui il Giappone è nascosto nel gioco. Quindi questi paesi saranno dipinti con tali colori.`,
  help3: `Una volta al giorno, è disponibile un nuovo paese nascosto. Oppure passa alla modalità gratuita nelle impostazioni e gioca senza limiti.`,
  France: "Francia",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "Corea del Sud",
  Aux1: `<b>["Clicca", "Tocca"]</b> il globo per iniziare!`,
  Loading: "Aspettalo...",
  GameTitle: "Gioco",
  Game1: "Inserisci qui il nome del paese",
  Game2: "Invio",
  Game3: "Digita un nome di paese casuale e premi Invio per iniziare",
  Game4: `Ruota, <span>["fai clic", "tocca"]</span> e ingrandisci il globo per trovare il prossimo paese da indovinare`,
  Game5: "Non conosciamo questo paese",
  Game6: "Questo paese è già inserito",
  Game7: "Il Paese Nascosto era la {answer}!",
  Game8: "Confine più vicino",
  StatsTitle: "Statistiche",
  Stats1: "Ultima vittoria",
  Stats2: "Le ipotesi di oggi",
  Stats3: "Giochi vinti",
  Stats4: "Serie attuale",
  Stats5: "Serie massima",
  Stats6: "Ipotesi nella media",
  Stats7: "Ipotesi nella media",
  Stats8: "Ripristina",
  Stats9: "Condividere",
  Stats10: "Sei sicuro di voler azzerare il tuo punteggio?",
  Stats11: "Statistiche cancellate.",
  Stats12: "Copiato negli appunti!",
  SettingsTitle: "Impostazioni",
  Settings1: "Tema del giorno",
  Settings2: "Tema notturno",
  Settings3: "Modalità daltonico attivata",
  Settings4: "Modalità daltonica disattivata",
  Settings5: "Paesi",
  Settings7: "Lingua",
  Settings9: "Modalità libera",
  Answer: "Risposta",
  Closest: "Più vicino",
  Guessed: "Indovinato",
  PracticeMode: "Sei in modalità gratuita.",
  PracticeExit: "Esci dalla modalità libera",
  PracticeNew: "Nuovo gioco gratuito",
  PlayAgain: "Gioca di nuovo",
  SortBy: "Ordina per:",
  SortByGuesses: "indovinare l'ordine",
  SortByDistance: "distanza",
  Clipboard: "🌍🌍🌍\nHo indovinato il paese nascosto nel Globle di oggi in {X} ipotesi\nPuoi farlo meglio?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Vittoria",
  Guesses: "Indovina",
};